module.exports = __webpack_public_path__ + "media/Components/fonts/LobsterTwo-3fa2e7a5ef647f8da1f2b1acabd8cbde.ttf";